import { pages } from './pages';

export const companies = [pages.construction, pages.manpower, pages.engineering];
